import { Utils } from '../../../helpers'
import { IEntityMappingConfig, EntityMapping, EntityMappingFactory } from './'

export class EntityMappingManager {

  private _mappingRegistry: Map<string, EntityMapping> = new Map<string, EntityMapping>()

  public constructor(
    entityMappingConfigs: IEntityMappingConfig[],
    private _entityMappingFactory: EntityMappingFactory,
    private _utils: Utils,
  ) {
    entityMappingConfigs.forEach((entityMappingConfig) => {
      this._registerEntityMapper(entityMappingConfig)
    })
  }

  public forJson(jsonEntityName: string): EntityMapping {
    const mapper = this._mappingRegistry.get(jsonEntityName)
    return mapper || this._registerEntityMapper(
      this._generateDefaultMappingConfig(this._utils.pascalCase(jsonEntityName), jsonEntityName, {})
    )
  }

  public forClass(className: string): EntityMapping {
    const mapper = this._mappingRegistry.get(className)
    return mapper || this._registerEntityMapper(
      this._generateDefaultMappingConfig(className, this._defaultJsonName(className), {})
    )
  }

  private _generateDefaultMappingConfig(classType: string, jsonType: string, propertyMapping: {}) {
    return {
      classType: classType,
      jsonType: jsonType,
      propertyMapping: propertyMapping
    }
  }

  private _defaultJsonName(className: string) {
    // TODO [GitHub Issue]: the addition of the 's' to the end of this default string can be Jsonapi specific. Therefore, there should be
    // a perhaps a jsonFormatter object that understands how to properly formatt these default strings
    return `${this._utils.dashCase(className)}s`
  }

  private _registerEntityMapper(entityMappingConfig: IEntityMappingConfig): EntityMapping {
    const entityMapping = this._entityMappingFactory.get(entityMappingConfig)
    this._mappingRegistry.set(entityMappingConfig.classType, entityMapping)
    this._mappingRegistry.set(entityMappingConfig.jsonType, entityMapping)
    return entityMapping
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/entity-mapping-manager/entity-mapping-manager.ts